const userLogin = (state, payload) => {
  state.userLoginDetails = payload; 
}

const userDetails = (state, payload) => {
  state.userDetails = payload
}

export default {
  userLogin,
  userDetails,
}


// WEBPACK FOOTER //
// ./src/store/modules/authentication/mutations.js